<template>
  <div class="conatiner-loading">
    <div class="spinner"></div>
      <div class="base-loading">{{ mgs }}</div>
  </div>
</template>

<script>
export default {
  name: "LoadingDados",
  props: ['mgs'],
  data() {
    return {
      msg: { default: 'Aguarde....'}
    }
  }
}
</script>

<style scoped>
.conatiner-loading {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  position: fixed;
  align-items: center;
  top: 0;
  z-index: 699999999999;
  background: #fff;
}

.base-loading {
  font-size: initial !important;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  font-weight: bold;
  text-align: center;
  color: var(--bd-primary);
}

.spinner {
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-left-color: #0c5460;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 551px) {
  .conatiner-loading {
    height: 100% !important;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .spinner {
    width: 35px !important;
    height: 35px !important;
    margin-bottom: 10px;
  }
}
</style>